import {Route, Switch, BrowserRouter} from 'react-router-dom'
import routes from './routes'
import Home from '../pages/Home'
import Login from '../pages/Login'
import Password from '../pages/Password'
import Email from '../pages/Email'
import NewPasswordForm from '../components/organism/forms/NewPasswordForm'
import MainHeader from '../components/organism/MainHeader'
import Config from '../pages/Config'

const App = () => {
  return (
    <BrowserRouter>
      <MainHeader />
      <Switch>
        <Route path={routes.login} component={Login} />
        <Route path={routes.recover} component={Password} />
        <Route path={routes.email} component={Email} />
        <Route path={routes.reset} component={NewPasswordForm} />
        <Route path={routes.config} component={Config} />
        <Route path={routes.home} component={Home} />
      </Switch>
    </BrowserRouter>
  )
}

export default App
